import { useConfigStore } from '../store/config'

export interface ThemeType {
  colors: any
  shadows: any
  sm: string
  md: string
  lg: string
  xl: string
}

export const theme: ThemeType = {
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  colors: {
    primary: '#2c30af',
    secondary: '#b8b8b8',
    text: '#1e293b',
    background: '#b8b8b8',
    surface: 'rgba(255, 255, 255, 0.5)',
    placeholder: '#94a3b8',
    title: '#0f172a',
    header: '#2c30af',
    default: '#0f172a',
    drawer: '#ffffff',
    label: '#334155',
    input: '#0f172a',
    border: '#cbd5e1',
    error: '#ef4444',
    warning: '#f59e0b',
    success: '#10b981',
    buttonLabel: '#ffffff',
  },

  shadows: {
    softShadow: 'box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.08), 0 1px 2px -1px rgba(0, 0, 0, 0.05);',
    mediumShadow: 'box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.08), 0 2px 4px -2px rgba(0, 0, 0, 0.05);',
    largeShadow: 'box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -4px rgba(0, 0, 0, 0.04);',
  },
}
